import { fork, all } from 'redux-saga/effects'
import getBrandSuggestions from '../../../dataservices/getBrandSuggestions'
import getJerseyNameSuggestions from '../../../dataservices/getJerseyNameSuggestions'
// eslint-disable-next-line import/no-named-as-default, temporary until we only export the one thing
import actionTypes from '../../actionTypes'
import actions from '../../actionCreators'
import actionWorkflows from '../../actionWorkflows'
import { processSaga, watchSaga } from '../workflow'
import { shouldCallJerseyName } from './sagas'
import algoliaSearchItem from '../../../dataservices/algoliaSearchItem'
import algoliaSearchKit from '../../../dataservices/algoliaSearchKit'
import algoliaSearchUser from '../../../dataservices/algoliaSearchUser'

const brandSuggestionsFetchWorkflow = processSaga.bind(null, actions.brandSuggestions.fetch, getBrandSuggestions)
const jerseyNameSuggestionsFetchWorkflow = processSaga.bind(null, actions.jerseyNameSuggestions.fetch, getJerseyNameSuggestions)

const searchItemsWorkflow = processSaga.bind(null, actionWorkflows.searchItem, algoliaSearchItem)
const searchKitsWorkflow = processSaga.bind(null, actionWorkflows.searchKit, algoliaSearchKit)
const searchUsersWorkflow = processSaga.bind(null, actionWorkflows.searchUser, algoliaSearchUser)

export default function* root() {
	yield all([
		fork(watchSaga.bind(null, actionTypes.brandSuggestions.fetch.TRIGGER, brandSuggestionsFetchWorkflow, { latest: true })),
		fork(watchSaga.bind(null, actionTypes.jerseyNameSuggestions.fetch.TRIGGER, jerseyNameSuggestionsFetchWorkflow, { latest: true, shouldCall: shouldCallJerseyName })),
		fork(watchSaga.bind(null, actionTypes.searchItem, searchItemsWorkflow, { latest: true })),
		fork(watchSaga.bind(null, actionTypes.searchKit, searchKitsWorkflow, { latest: true })),
		fork(watchSaga.bind(null, actionTypes.searchUser, searchUsersWorkflow, { latest: true }))
	])
}



// WEBPACK FOOTER //
// ./src/redux/saga/search/index.js